import React from "react";

const Top = ({ toggleLanguage }) => {

  return <div></div>;
};

export default Top;
